<template lang="pug">
el-dialog.dialog-cancel-preorder(title='取消预订单', :visible='visible', :before-close='exit')
  .ui.form
    .ui.three.fields
      .ui.field
        label 定单人
        el-input(v-model='preorder.customer_name', disabled)
      .ui.field
        label 定单人电话
        el-input(v-model='preorder.customer_phone', disabled)
      .ui.field
        label 退回定金
        el-input(v-model='preorder.earnest_money', disabled)
    .ui.two.fields
      .ui.field
        label 退回定金
        el-input-number(v-model='form.refund_money', :controls='false')
      .ui.field
        label 退回定金
        payment-method-select(v-model='form.refund_method')
    .ui.two.fields
      .ui.field
        label 退定原因
        el-autocomplete(v-model='form.cancel_reason', :fetch-suggestions='reason_suggestions', placeholder='退定原因', @select='reason_select')
      .ui.field
        label 备注
        el-input(v-model='form.note')

    .actions

  div(slot='footer')
    .ui.button.themed(@click='submit') 确定取消预订单
    .ui.button(@click='exit()') 取消
</template>

<script>
import { MakeForm } from '../../utils'
import { PaymentMethodSelect } from '../basic'

export default {
  name: 'dialog-cancel-preorder',
  props: {
    room: Object,
    preorder: { type: Object, default() { return {} } },
    visible: { type: Boolean, default: false },
  },
  components: { PaymentMethodSelect },
  data() {
    return {
      form: {
        _id: null,
        refund_money: 0,
        refund_method: 'cash',
        note: '',
        cancel_reason: '',
      },
    }
  },
  mounted() {
    this.init()
  },
  watch: {
    preorder: {
      deep: true,
      handler() {
        this.init()
      },
    },
  },
  methods: {
    init() {
      if (this.preorder) {
        this.form = {
          _id: this.preorder._id,
          refund_money: this.preorder.earnest_money,
          refund_method: this.preorder.payment_method,
          note: '',
          cancel_reason: '',
        }
      }
    },
    reason_suggestions(_, callback) {
      callback([
        { value: '自行违约' },
        { value: '重复操作' },
        { value: '操作失误' },
      ])
    },
    reason_select(item) {
      this.form.cancel_reason = item.value
    },
    submit: MakeForm({
      type: 'put',
      url() { return `preorders/${this.form._id}/cancel` },
      confirm: '确定取消该预订单?',
      payload() {
        return this.form
      },
      $afterSuccess({ preorder }) {
        this.$templater.request('preorder_cancel', {
          preorder,
          room: this.room,
          $methods: this.$store.state.summary.payment_methods,
        })
        this.exit(preorder)
      },
    }),
    exit(body) {
      this.$emit('update:visible', false)
      if (body)
        this.$emit('exit', body)
    },
  },
}
</script>



// WEBPACK FOOTER //
// DialogCancelPreorder.vue?d997e0de